// @flow

import React from 'react';
import ResultData from 'components/ResultData/ResultData';
import ResultCard from 'components/ResultCard/ResultCard';
import ResultCardContainer from 'components/ResultCardContainer/ResultCardContainer';
import ShowAt from 'components/Viewport/ShowAt';
import HideAt from 'components/Viewport/HideAt';
import injectL10n from 'react-aaui/lib/shared/injectL10n';
import type { L10n } from 'type/type';

import './LastCrossedSplitBoard.scss';

type Props = {
  l10n: L10n,
  lastCrossedSplit: string
}

const LastCrossedSplitBoard = ({ lastCrossedSplit, l10n: { formatMessage } }: Props) => {
  const LastCrossedSplitMsg = formatMessage('page.participant.participantLiveHeader.lastCrossedSplit');
  return (
    <ResultCardContainer className="last-crossed-split-container">
      <ShowAt xlAndAbove>
        <ResultCard logo="icon-running">
          <ResultData
            type={LastCrossedSplitMsg}
            data={lastCrossedSplit}
            dataFont={20} />
        </ResultCard>
      </ShowAt>
      <HideAt xlAndAbove>
        <div className="last-crossed-split__mobile">
          <div className="last-crossed-split__mobile-icon"><i className="icon-running" /></div>
          <div className="last-crossed-split__mobile-message">{LastCrossedSplitMsg}</div>
          <div className="last-crossed-split__mobile-data">{lastCrossedSplit}</div>
        </div>
      </HideAt>
    </ResultCardContainer>
  );
};

export default injectL10n()(LastCrossedSplitBoard);
